/* eslint-disable react/prop-types */
import React from 'react';
import ReactPlayer from 'react-player';
import analytics from '../../../utils/analytics/analytics';
import { sentryCaptureException } from '../../../utils/sentry/sentry-client';

interface ReactPlayerVideoProps {
    url: string;
}

const trackVideoEvent = (params: {
    name: string;
    event: string;
    action: string;
    label: string;
}) => {
    const { name, event, action, label } = params;
    analytics.trackEvent(name, {
        event,
        eventComponent: 'video',
        category: 'video',
        action,
        label
    });
};

const handleOnError = (error: unknown) => {
    sentryCaptureException({
        exception: error
    });
    trackVideoEvent({
        name: 'videoPlayerError',
        event: 'video_error',
        action: 'error',
        label: 'Video player error'
    });
};

const handleOnStart = () => {
    trackVideoEvent({
        name: 'videoPlayerStart',
        event: 'video_started',
        action: 'start',
        label: 'Video player start'
    });
};

const handleOnEnded = () => {
    trackVideoEvent({
        name: 'videoPlayerEnd',
        event: 'video_ended',
        action: 'end',
        label: 'Video player end'
    });
};

const ReactPlayerVideo: React.FC<ReactPlayerVideoProps> = ({ url }) => {
    return (
        <div className="component-video__container">
            <ReactPlayer
                className="component-video__iframe"
                url={url}
                width="100%"
                height="100%"
                controls={true}
                onError={handleOnError}
                onStart={handleOnStart}
                onEnded={handleOnEnded}
            />
        </div>
    );
};

export default ReactPlayerVideo;
